class PersonalMandatorySerializer {
  static serialize(user: MandatoryFieldsType): PersonalMandatoryFieldsRaw {
    return {
      name: user.name,
      email: user.email,
      password: user.password,
    };
  }
}

export { PersonalMandatorySerializer };
